<template>
  <section class="my-vaccine-pass kioskBody" :class="{ show }" :style="{
    ...(
      data && data.branding && data.branding.kioskBackgroundUrl
        ? {
          backgroundImage: `url(${data.branding.kioskBackgroundUrl})`
        } : {}
    )
  }">
    <div v-if="!showQR && qrCodeKioskSignInType === 1" class="vaccine-pass-container">
      <p class="title">Do you have a <b>My Vaccine Pass?</b></p>
      <div class="vaccine-pass-body">
        <div class="left">
          <img src="../assets/my-vaccine-pass.png"/>
        </div>
        <div class="right">
          <div class="row-container justify-start">
            <p class="yes-text">Yes, sign-in with QR Code</p>
          </div>
          <div class="row-container justify-center">
            <button class="btn-primary" @click="scanMyVaccinePass">
              SCAN QR CODE
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M21 21v3h3v-3h-1v-1h-1v1h-1zm2 1v1h-1v-1h1zm-23 2h8v-8h-8v8zm1-7h6v6h-6v-6zm20 3v-1h1v1h-1zm-19-2h4v4h-4v-4zm8-3v2h-1v-2h1zm2-8h1v1h-1v-1zm1-1h1v1h-1v-1zm1 2v-1h1v1h-1zm0-2h1v-6h-3v1h-3v1h3v1h2v3zm-1-4v-1h1v1h-1zm-7 4h-4v-4h4v4zm6 0h-1v-2h-2v-1h3v1h1v1h-1v1zm-4-6h-8v8h8v-8zm-1 7h-6v-6h6v6zm3 0h-1v-1h2v2h-1v-1zm-3 3v1h-1v-1h1zm15 6h2v3h-1v-1h-2v1h-1v-1h-1v-1h1v-1h1v1h1v-1zm-4 2h-1v1h-1v-1h-1v-1h1v-1h-2v-1h-1v1h-1v1h-2v1h-1v6h5v-1h-1v-2h-1v2h-2v-1h1v-1h-1v-1h3v-1h2v2h-1v1h1v2h1v-2h1v1h1v-1h1v-2h1v-1h-2v-1zm-1 3h-1v-1h1v1zm6-6v-2h1v2h-1zm-9 5v1h-1v-1h1zm5 3v-1h1v2h-2v-1h1zm-3-23v8h8v-8h-8zm7 7h-6v-6h6v6zm-1-1h-4v-4h4v4zm1 4h1v2h-1v1h-2v-4h1v2h1v-1zm-4 6v-3h1v3h-1zm-13-7v1h-2v1h1v1h-3v-1h1v-1h-2v1h-1v-2h6zm-1 4v-1h1v3h-1v-1h-1v1h-1v-1h-1v1h-2v-1h1v-1h4zm-4-1v1h-1v-1h1zm19-2h-1v-1h1v1zm-13 4h1v1h-1v-1zm15 2h-1v-1h1v1zm-5 1v-1h1v1h-1zm-1-1h1v-3h2v-1h1v-1h-1v-1h-2v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v1h-1v-1h1v-1h-4v1h2v1h-2v1h1v2h1v-1h2v2h1v-4h1v2h3v1h-2v1h2v1zm1-5h1v1h-1v-1zm-2 1h-1v-1h1v1z"/>
              </svg>
            </button>
          </div>
          <div class="row-container justify-start">
            <span class="qr-note">Quicky sign-in with your My Vaccine Pass</span>
          </div>
          <hr class="custom-hr" />
          <div class="row-container justify-start">
            <p class="no-text">No, I don't have My Vaccine Pass</p>
          </div>
          <div class="row-container justify-center">
            <button class="btn-primary" @click="goToLocationSignIn">
              NEXT
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/>
              </svg>
            </button>
          </div>
          <div class="row-container justify-start">
            <span class="qr-note">Other checks of your vaccine status may be required.</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showQR" class="scan-vaccine-pass-container">
      <p class="title">Scan <b>My Vaccine Pass</b></p>
      <div class="row-container qr-body">
        <qrcode-stream
          :key="_uid"
          :camera="camera"
          @decode="onDecode"
          @detect="onDetect"
          :track="paintBoundingBox"
          @init="onInit"
        >
          <div class="loading-indicator" v-if="loading">Loading...</div>

          <div v-if="validationSuccess" class="validation-success">
            Success. Redirecting...
          </div>

          <div v-if="validationFailure" class="validation-failure">
            Invalid QR Code
          </div>

          <div v-if="validationPending" class="validation-pending">
            Validation in progress...
          </div>
        </qrcode-stream>
      </div>
      <div class="row-container">
        <button class="btn-primary" @click="cancelQr">
          <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M17.026 22.957c10.957-11.421-2.326-20.865-10.384-13.309l2.464 2.352h-9.106v-8.947l2.232 2.229c14.794-13.203 31.51 7.051 14.794 17.675z"/>
          </svg>
          CANCEL
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import config from "../../api_config.json";
import { QrcodeStream } from "vue-qrcode-reader";
import { verifyPassURI } from "@vaxxnz/nzcp";
import { getCheckInDataMixin } from "@/mixins.js";

export default {
  props: ["data", "qrCodeKioskSignInType"],
  mixins: [getCheckInDataMixin],
  data() {
    return {
      baseUrl: config.baseUrl,
      show: true,
      showQR: this.qrCodeKioskSignInType === 2 ? true : false,
      loading: false,
      camera: "front",
      isValid: undefined,
      result: null,
      credentialSubject: {}
    };
  },
  components: {
    QrcodeStream
  },
  computed: {
    validationPending() {
      return this.isValid === undefined && this.camera === "off";
    },
    validationSuccess() {
      return this.isValid === true;
    },
    validationFailure() {
      return this.isValid === false;
    },
  },
  methods: {
    scanMyVaccinePass() {
      this.showQR = true;
    },
    cancelQr() {
      if (this.qrCodeKioskSignInType === 2) {
        this.show = false;
        this.showQR = false;
        this.$parent.$refs.welcomeScreen.show = true;
      } else {
        this.showQR = false;
      }
    },
    async onInit(promise) {
      this.loading = true;

      try {
        await promise;
      } catch (error) {
        const triedFrontCamera = this.camera === 'front';
        const cameraMissingError = error.name === 'OverconstrainedError';

        if (triedFrontCamera && cameraMissingError) {
          this.camera = "auto";
        }
        console.error(error);
      } finally {
        this.loading = false;
        this.resetValidationState();
      }
    },
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height },
        } = detectedCode;

        ctx.lineWidth = 2;
        ctx.strokeStyle = "#007bff";
        ctx.strokeRect(x, y, width, height);
      }
    },
    resetValidationState() {
      this.isValid = undefined;
    },
    async onDetect (promise) {
      console.log('onDetect');
      try {
        const {
          content,      // decoded String
          location      // QR code coordinates
        } = await promise;
        console.log('Content', content);
        console.log('Location', location);
      }
      catch (error) {
        console.log('Error in onDetect', error);
      }  
    },
    async onDecode(content) {
      console.log("content >>> ", content);
      sessionStorage.setItem("qrCodeContent", content);
      this.result = content;
      this.turnCameraOff();

      // verify pass with production issuer
      //const wrongIssResult = await verifyPassURI(this.result);
      //console.log("wrongIssResult", wrongIssResult);

      // verify pass with staging issuer  
      let verifyOpts = {};

      if (config.env == 'dev') {
        verifyOpts = {
          trustedIssuer: "did:web:nzcp.covid19.health.nz",
        };
      }
      const validPassResult = await verifyPassURI(this.result, verifyOpts);
      const {success, credentialSubject} = validPassResult;
      console.log("validPassResult", validPassResult);

      // pretend it's taking really long
      await this.timeout(3000);
      this.isValid = success;
      this.credentialSubject = credentialSubject;
      // some more delay, so users have time to read the message
      await this.timeout(2000);

      if (success) {
        this.getLocalPostCallback();
      }
      this.turnCameraOn();
    },
    turnCameraOn() {
      this.camera = "front";
    },
    turnCameraOff() {
      this.camera = "off";
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    getLocalPostCallback() {
      console.log("this.$parent.userData >>> ", this.$parent.userData);
      const {givenName, familyName} = this.credentialSubject;
      let userData = this.$parent.userData;
      userData.visitor.name = `${givenName} ${familyName}`;
      console.log("userData >>> ", userData);

      this.showQR = false;
      this.goToLocationSignIn();
      this.$emit('signin', userData, true, true);
    },
    goToLocationSignIn() {
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-vaccine-pass:not(.show) {
  opacity: 0;
  pointer-events: none;
}

.loading-indicator,
.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.loading-indicator, .validation-pending {
  color: #1b57be;
}

.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
</style>
